import styled from 'styled-components';

import {BasicPageWrapper} from '../../Theme/basicElements';

export const ContactUsWrapper = styled(BasicPageWrapper)`

`;
